/**
 * @typedef {Object} RouterTaskStates
 * @property {String} activityFeed
 * @property {String} requirements
 * @property {String} tasks
 * @property {String} timerLog
 */

/** @type {RouterTaskStates} */
export const assetTasksStates = {
  activityFeed: 'app.assets.tasks-activity-feed',
  requirements: 'app.assets.tasks-requirements',
  tasks: 'app.assets.tasks',
  timerLog: 'app.assets.tasks-timer-log',
};

/** @type {RouterTaskStates} */
export const templateTasksStates = {
  activityFeed: 'app.projects.asset-tasks-activity-feed',
  requirements: 'app.projects.asset-tasks-requirements',
  tasks: 'app.projects.asset-tasks',
};

/** @type {RouterTaskStates} */
export const projectTasksStates = {
  activityFeed: 'app.projects.tasks-activity-feed',
  requirements: 'app.projects.tasks-requirements',
  tasks: 'app.projects.tasks',
  timerLog: 'app.projects.tasks-timer-log',
};



// WEBPACK FOOTER //
// ./src/js/tasks/router-config.js